// window.Packs.shared.Backbone
export { Backbone } from 'backbone/shared/shared.js';

import ImageUtils from 'utils/shared/image_utils.js';
import Url from 'utils/shared/url.js';

const Utils = {
  ImageUtils,
  Url
};

export { Utils };



// WEBPACK FOOTER //
// ./app/javascript/packs/shared.js